import { ConectoresConexaoCadastro } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/configuracao/:idConfiguracao/conexao/:id',
    text: 'Conexão',
    component: ConectoresConexaoCadastro,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
